
import {catchError,  map, share } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpResponseHandlerService } from '../services/http-response-handler.service';
import * as _ from 'underscore';



@Injectable()
export class AjaxObservableService {

  header;
  constructor(private http: HttpClient,
    private httpResponseHandlerService: HttpResponseHandlerService)
  { }
  
  get(searchParams: any, url: any): Observable<String> {
    let apiUrl = environment.apiUrl + url;
    return this.http.get(apiUrl, { withCredentials: true, params: searchParams }).pipe(map(res => {
      return this.httpResponseHandlerService.handleHTTPResponse(res);
    }), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }
  post(url, params): Observable<void> {
    this.header = new HttpHeaders({
      "content-type": "application/x-www-form-urlencoded",
      "accept": "application/json, text/plain, */*"
    });
    return this.http.post(environment.apiUrl + url, params, { withCredentials: true, headers: this.header }).pipe(map(res => {
      return this.httpResponseHandlerService.handleHTTPResponse(res);
    }), share()).pipe(catchError((e: any) => {
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }

  getUrlParams(fields): HttpParams {
    let urlParams = new HttpParams();
    _.each(fields, function (value, key) {
      urlParams = urlParams.append(key,value);
    });
    return urlParams;
  }

  dropBonus(payload) { 
    return this.get(this.getUrlParams(payload), '/ajax//bonus/drop');
  }

  getEligibleBonus(request) {
    return this.get(this.getUrlParams(request),'/ajax/bonus/getEligibleBonuses');
  }

  getZendeskToken() {
    return this.get('', '/ajax/profile/getZendeskToken');
  }

  getFreshChatToken(uuid) {
    return this.get('', '/ajax/profile/getFreshChatToken?uuid='+uuid);
  }

  getZendeskRubikoDetails(userName) {
    let url = 'https://zdapi.rubiko.tech/tracking?user='+ encodeURIComponent(userName) + '&page=' + encodeURIComponent(window.location.href)
    return this.http.get(url);
  }

}
